module.exports = __webpack_public_path__ + "img/photoshop-logo.8ca8f89d.svg";